const topics = [
  { id: 1, name: '热播电视剧', count: '2.3万', hot: true },
  { id: 2, name: '院线大片', count: '1.8万', hot: true },
  { id: 3, name: '日韩剧集', count: '1.5万', hot: true },
  { id: 4, name: '国漫崛起', count: '1.2万', hot: false },
  { id: 5, name: '综艺娱乐', count: '9800', hot: false },
  { id: 6, name: '悬疑推理', count: '8600', hot: false },
  { id: 7, name: '科幻巨制', count: '7200', hot: false },
  { id: 8, name: '喜剧搞笑', count: '6500', hot: false },
  { id: 9, name: '纪录纪实', count: '5100', hot: false },
  { id: 10, name: '经典回顾', count: '4800', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-hashtag"></i>
            <span>话题热度</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            大家都在关注的热门话题，找到你感兴趣的影视内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#media');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group flex items-center gap-2 px-5 py-3 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200/70 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              {topic.hot && (
                <i className="ri-fire-line text-primary-500 text-sm"></i>
              )}
              <span className="text-sm font-medium">{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-primary-400' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}